module.exports = __webpack_public_path__ + "static/img/jt.35c25101.jpg";